import { TextField } from "@material-ui/core";
import { Autocomplete, AutocompleteProps } from "@material-ui/lab";
import MyTypography from "@saleor/components/MyTypography";
import ChevronDownAutocomplete from "@saleor/icons/ChevronDownAutocomplete";
import React, { useEffect, useRef, useState } from "react";

import useStyles from "./styles";

interface SingleAutocompleteProps
  extends Omit<
    AutocompleteProps<any, boolean, boolean, boolean>,
    "renderInput"
  > {
  name?: string;
  options: any[];
  error?: boolean;

  onChange?(event: any);
}

const SingleAutocomplete: React.FC<SingleAutocompleteProps> = ({
  options,
  placeholder,
  value,
  name,
  onChange,
  renderOption,
  error,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();
  const [rawValue, setValue] = useState(value);
  const [option, setOption] = useState(null);

  const handleChange = (_, option) => {
    onChange({
      target: {
        name,
        value: option.value
      }
    });
    setValue(option.value);
  };
  useEffect(() => {
    const option = options.find(option => option.value === rawValue);
    setOption(option || null);
  }, [rawValue, options]);

  return (
    <div>
      <Autocomplete
        {...rest}
        value={option}
        classes={{ paper: classes.paper }}
        className={classes.root}
        disableClearable
        popupIcon={<ChevronDownAutocomplete />}
        options={options}
        renderOption={
          renderOption
            ? renderOption
            : option => (
                <MyTypography variant={"inherit"} className={classes.label}>
                  {option.label}
                </MyTypography>
              )
        }
        selectOnFocus={null}
        openOnFocus
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            inputRef={inputRef}
            name={name}
            error={error}
          />
        )}
        onChange={handleChange}
      />
    </div>
  );
};

export default SingleAutocomplete;
